//@ts-ignore
import style from "./style/Login.module.css";
import BusinessSelectView from "./view/BusinessSelect.view";
import LoginForm from "./view/LoginForm/LoginForm.view";
import LoungesSelectView from "./view/LoungesSelect.view";
import useInitialState from "./hook/initialState";
import { APP_VERSION } from "@Models/version";

export const Login = () => {
  const initialState = useInitialState();
  const { currentView } = initialState;

  return (
    <section className={style.section}>
      {currentView === 0 && <LoginForm {...initialState} />}
      {currentView === 1 && <BusinessSelectView {...initialState} />}
      {currentView === 2 && <LoungesSelectView {...initialState} />}
      <span className={style.versionLabel}>Prikly {APP_VERSION}</span>
    </section>
  );
};
